import { createContext, useContext } from 'react'
import { DefaultDurations, DEFAULT_DURATIONS } from './types'

interface DispositionConfigContextValue {
  workOrderId: string
  defaultDurations: DefaultDurations
  ghostColor: string | undefined
  onDraftFinalized: ((
    technicianId: string,
    technicianName: string | null,
    anfahrtStartIso: string,
    durations: DefaultDurations,
    tradeCode?: number,
  ) => void) | undefined
}

const DispositionConfigContext = createContext<DispositionConfigContextValue>({
  workOrderId: '',
  defaultDurations: DEFAULT_DURATIONS,
  ghostColor: undefined,
  onDraftFinalized: undefined,
})

export const DispositionConfigProvider = DispositionConfigContext.Provider

export function useDispositionConfig(): DispositionConfigContextValue {
  return useContext(DispositionConfigContext)
}
